module.exports = __webpack_public_path__ + "static/media/online-doctor-header-image.6509406d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-doctor-header-image.png
// module id = 392
// module chunks = 0